// extracted by mini-css-extract-plugin
export var colorSquare = "_rc-0";
export var danger = "_rc-5";
export var lightPink = "_rc-8";
export var neutralBlue = "_rc-7";
export var neutralYellow = "_rc-6";
export var normal = "_rc-1";
export var primary = "_rc-2";
export var primaryLight = "_rc-3";
export var solidBlack = "_rc-g";
export var solidGreen = "_rc-b";
export var solidLightBlue = "_rc-d";
export var solidNavy = "_rc-c";
export var solidOrange = "_rc-f";
export var solidPink = "_rc-e";
export var solidRed = "_rc-9";
export var solidYellow = "_rc-a";
export var success = "_rc-4";